export default "__VITE_ASSET__Os_AK3q4__"